import React from 'react';
import '../styles/ParentInfoModal.css';

interface Props {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<Props> = ({ open, title = 'Are you sure?', message, confirmText = 'Confirm', cancelText = 'Cancel', onConfirm, onCancel }) => {
  if (!open) return null;
  return (
    <div className="modal-overlay">
      <div className="parent-info-modal">
        <div className="modal-header">
          <h3>{title}</h3>
        </div>
        <div style={{ padding: '1rem 1.5rem' }}>
          <p style={{ margin: 0 }}>{message}</p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 16 }}>
            <button className="retry-button" onClick={onCancel}>{cancelText}</button>
            <button className="view-button" onClick={onConfirm}>{confirmText}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;


